import React, { useState } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { styled, alpha } from '@mui/material/styles';
import EditWaivers from '../EditWaivers';
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import {hasPermission,useRolePermissions} from '@projectK/context/RolesProvider';
import PropTypes from 'prop-types';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  padding: 8,
  '&:first-of-type': {
    paddingLeft: 20,
  },
  '&:last-of-type': {
    paddingRight: 20,
  },
  '& .icon-btn': {
    border: `solid 1px ${alpha('#F84E4E', 1.0)}`,
    color: alpha('#F84E4E', 1.0),
    padding: 3,
    fontSize: 20,
    '&:not(:first-of-type)': {
      marginLeft: 8,
    },
  },
  '& .icon-btn-eye': {
    border: `solid 1px ${alpha(theme.palette.primary.main, 1.0)}`,
    color: alpha(theme.palette.primary.main, 1.0),
  },
  '&:hover': {
    '& .icon-btn': {
      border: `solid 1px #F84E4E`,
      color: '#F84E4E',
    },
    '& .icon-btn-eye': {
      border: `solid 1px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
}));
const TableItem = ({ data, fetchData, onDelete, verbiageSettings }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { rolePermissions } = useRolePermissions(); 
  const handleEditClick = () => {
    setIsEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
  };
  const parseContent = (content) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    return doc.body.textContent || '';
  };
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const handleDelete = (itemId) => {
    setItemToDelete(itemId);
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = () => {
    onDelete(itemToDelete);
    setDeleteConfirmationOpen(false);
  };

  const handleCancelDelete = () => {
    setDeleteConfirmationOpen(false);
  };
  return (
    <TableRow key={data.waiver_name} className='item-hover'>
      <StyledTableCell align='left'>
      <Box className='textwrap'>
        {data.waiver_name}
        </Box>
        </StyledTableCell>
      <StyledTableCell align='left'>
      <Box className='textwrap1'>
        {parseContent(data.description).substring(0, 50)}...
        </Box>
      </StyledTableCell>
      <StyledTableCell align='left'>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
            {hasPermission(rolePermissions, 'Company Settings - Waiver Settings', 'update') && (
          <IconButton
            size='small'
            className='icon-btn icon-btn-eye'
            onClick={handleEditClick}
          >
            <AiOutlineEdit />
          </IconButton>
            )}
              {hasPermission(rolePermissions, 'Company Settings - Waiver Settings', 'delete') && (
          <IconButton
            size='small'
            className='icon-btn'
            onClick={() => handleDelete(data.id)}
          >
            <AiOutlineDelete />
          </IconButton>
              )}
        </div>
      </StyledTableCell>
      <Dialog
        open={deleteConfirmationOpen}
        onClose={handleCancelDelete}
        maxWidth='xs'
      >
        <DialogTitle>
          <Typography variant='h4'>Confirm Deletion</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
            Are you sure you want to delete this waiver?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleConfirmDelete} color='primary'>
            Yes
          </Button>
          <Button onClick={handleCancelDelete} color='secondary'>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <EditWaivers
        isOpen={isEditModalOpen}
        onClose={handleCloseModal}
        waiverData={data} // Pass the data of the clicked item
        fetchData={fetchData}
        verbiageSettings={verbiageSettings}
      />
    </TableRow>
  );
};

export default TableItem;
TableItem.propTypes = {
  data: PropTypes.array,
  onDelete: PropTypes.func,
  fetchData: PropTypes.func,
  verbiageSettings: PropTypes.object,
};
